export const errorException = [
  "CANT_DELETE_TEAM_MEMBER",
  "INVITE_ERROR_NOTFOUND_OR_EXPIRED",
  "INVITE_ERROR_PHONE_EMAIL_EXISTS",
];
